module.exports = __webpack_public_path__ + "img/fig05.3db2d63a.jpg";